<template>
	<div id="content">
		<shutter-panel ref="shutterPanel" />
	</div>
</template>

<script type="text/javascript">
	import ShutterCongelation from "@/mixins/shutters-manager/Congelation.js"

	export default {
		name: 'Expedition',
		mixins: [ShutterCongelation],
		props: ['horse_id', 'status', 'demandeur_id', 'destinataire_id'],
		mounted() {
			this.init_component()
		},
		methods: {
			init_component() {
				this.setUpExpeditionList(this.horse_id, this.status, this.demandeur_id, this.destinataire_id)
			}
		},
		watch: {
			status() {
				this.init_component()
			},
			demandeur_id() {
				this.init_component()
			},
			destinataire_id() {
				this.init_component()
			}
		}
	}
</script>